import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

export interface RepositoryItemContextData {
  showDeleteCampaignModal: boolean;
  onOpenDeleteCampaignModal: () => void;
  onCloseDeleteCampaignModal: () => void;
}

export const RepositoryItemContext = createContext<RepositoryItemContextData | null>(
  null
);

interface RepositoryItemProviderProps {
  children: ReactNode;
}

export const RepositoryItemProvider = ({
  children,
}: RepositoryItemProviderProps) => {
  const [showDeleteCampaignModal, setShowDeleteCampaignModal] = useState<
    boolean
  >(false);

  const onOpenDeleteCampaignModal = useCallback(
    () => setShowDeleteCampaignModal(true),
    [setShowDeleteCampaignModal]
  );

  const onCloseDeleteCampaignModal = useCallback(
    () => setShowDeleteCampaignModal(false),
    [setShowDeleteCampaignModal]
  );

  return (
    <RepositoryItemContext.Provider
      value={{
        showDeleteCampaignModal,
        onOpenDeleteCampaignModal,
        onCloseDeleteCampaignModal,
      }}
    >
      {children}
    </RepositoryItemContext.Provider>
  );
};

export const useRepositoryItemContext = (): RepositoryItemContextData => {
  const repositoryItemContext = useContext(RepositoryItemContext);

  if (!repositoryItemContext) {
    throw new Error('context must be used inside a provider');
  }

  return repositoryItemContext;
};
